<template>
  <div>
    <h1>Editar contato do concedente</h1>
    <b-card>
      <Form
        @saved="loadData"
        :concedente_contato_id="$route.params.id ?? null"
      />
    </b-card>
  </div>
</template>

<script setup>
import { useNotify } from "@/composables/useNotify";
import Form from "@/modules/concedentes_contatos/Components/Form.vue";
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router/dist/composables.js";
import { useActions } from "vuex-composition-helpers";

const $notifications = useNotify();
const $router = useRouter();
const $route = useRoute();

const { ActionNewConcedenteContato, ActionShow } = useActions(
  "concedentes_contatos",
  ["ActionNewConcedenteContato", "ActionShow"]
);

async function loadData(id) {
  try {
    await ActionShow(id);
  } catch (error) {
    $notifications.addNotification({
      message: error.data.responseMessage,
      icon: "exclamation-triangle",
      type: "danger",
    });

    $router.back();
  }
}

onMounted(() => {
  ActionNewConcedenteContato();
  loadData($route.params?.id);
});
</script>
